import html from '../components/assets/html.png';

import css from '../components/assets/css.png';
import javascript from '../components/assets/javascript.png';
import tailwind from '../components/assets/tailwind.png';
import redux from '../components/assets/redux.png';
import react from '../components/assets/react.png';
import firebase from '../components/assets/firebase.png';
import Ecommerce from '../components/assets/HeroSection.png';
import Portfolio from '../components/assets/Portfolio.png';
import Space from '../components/assets/space.png';
import redesign from '../components/assets/redesign.png';
import next from '../components/assets/next.png';
import figma from '../components/assets/figma.png';
import appnext from '../components/assets/appnext.png';
// import Facebook from '../components/assets/facebook.png';
// import Twitter from '../components/assets/twitter.png';
import LinkedIn from '../components/assets/linkedin.png';
// import Instagram from '../components/assets/instagram.png';
export const contacts = [
  // {
  //   img: Facebook,
  //   title: 'Facebook',
  //   textColor: 'text-[#497fbd]',
  // },
  // {
  //   img: Twitter,
  //   title: 'Twitter',
  //   textColor: 'text-[#03a9f4]',
  // },
  {
    img: LinkedIn,
    title: 'LinkedIn',
    textColor: 'text-[#faffff]',
    url: 'https://www.linkedin.com/in/nisat-islam',
  },
  // {
  //   img: Instagram,
  //   title: 'Instagram',
  //   textColor: 'text-[#f85500]',
  // },
];
export const projects = [
  {
    title: 'Web Next App',
    img: redesign,
    tech: {
      react: 'React',
      next: 'Next',

      css: 'Tailwind',
    },
    description: (
      <p>
        This is the complete re-design of the previous Web development company
        website that I developed. I designed this on figma and developed this
        with the help of React js , Next js and Tailwind css.
      </p>
    ),
    live: 'https://webnextapp.vercel.app/',
    code: 'https://github.com/Nisat-Islam/webnextapp',
  },
  {
    title: 'AppNext IT',
    img: appnext,
    tech: {
      react: 'React',
      next: 'Next',

      css: 'Tailwind',
    },
    description: (
      <p>
        This is a Web Development Company website that I developed couple of
        month's ago.
      </p>
    ),
    live: 'https://appnext-it.vercel.app/',
    code: 'https://github.com/Nisat-Islam/e-commerce-app',
  },
  {
    title: 'Portfolio',
    img: Portfolio,
    tech: {
      react: 'React',

      css: 'Tailwind',
    },
    description: (
      <p>
        The Portfolio.
        <br /> Every animation on this website is custom made. No third party
        Animation library has been used.{' '}
      </p>
    ),
    live: 'https://nisad-ecommerce.netlify.app/',
    code: 'https://github.com/Nisad-tushar/e-commerce-app',
  },
  {
    title: 'E - Commerce',
    img: Ecommerce,
    tech: {
      react: 'React',
      redux: 'Redux,',
      css: 'Tailwind',
      firebase: 'Firebase',
    },
    description:
      'An e-commerce website that I  developed with  power of the React , Redux , Tailwind and Firebase by my side',
    live: 'https://nisad-ecommerce.netlify.app/',
    code: 'https://github.com/Nisad-tushar/e-commerce-app',
  },
  {
    title: 'Space Tourism',
    img: Space,
    tech: {
      react: 'React',

      css: 'Tailwind',
    },
    description:
      'Built entirely from  figma files provided by Front End mentor challenge. ',
    //And as usual, I have garnished the designs with my own imagination.',
    code: 'https://github.com/Nisad-tushar/space-tourism-app',
  },
];

export const skills = [
  {
    title: 'Figma',
    img: figma,
    color: 'text-green-600',
    bgColor: 'hover:bg-[#ee662c]',
    anime: 'info',
  },
  {
    title: 'HTML',
    img: html,
    color: 'text-[#ee662c]',
    bgColor: 'hover:bg-[#ee662c]',
    anime: 'heading',
  },
  {
    title: 'CSS',
    img: css,
    color: 'text-[#039be6]',
    bgColor: 'hover:bg-[#039be6]',
    anime: 'info',
  },
  {
    title: 'Tailwind',
    img: tailwind,
    color: 'text-[#07b6d5]',
    bgColor: 'hover:bg-[#07b6d5]',
    anime: 'heading',
  },
  {
    title: 'Javascript',
    img: javascript,
    color: 'text-[#feda3e]',
    bgColor: 'hover:bg-[#feda3e]',
    anime: 'info',
  },
  {
    title: 'React',
    img: react,
    color: 'text-[#07b6d5]',
    bgColor: 'hover:bg-[#07b6d5]',
    anime: 'heading',
  },
  {
    title: 'Next',
    img: next,
    color: 'text-white',
    bgColor: 'hover:bg-[#07b6d5]',
    anime: 'info',
  },
  {
    title: 'Redux',
    img: redux,
    color: 'text-[#7749bc]',
    bgColor: 'hover:bg-blue-500',
    anime: 'info',
  },
  {
    title: 'Firebase',
    img: firebase,
    color: 'text-[#fbca3f]',
    bgColor: 'hover:bg-[#fbca3f]',
    anime: 'heading',
  },
];
